/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseAppearanceFieldLayout
 */
export interface DatabaseAppearanceFieldLayout {
    /**
     * flow of the fields
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    alignment?: DatabaseAppearanceFieldLayoutAlignmentEnum;
    /**
     * alignment of the labels
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    labelAlignment?: DatabaseAppearanceFieldLayoutLabelAlignmentEnum;
    /**
     * Verhaeltnis Label-Spalte zu Eingabe-Spalte bei
     * labelAlignment=LEFT|RIGHT. Wirkt nicht bei TOP/TOP_CENTERED.
     * Wenn nicht gesetzt: Default je Alignment — LEFT=35:65, RIGHT=50:50.
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    labelColumnRatio?: DatabaseAppearanceFieldLayoutLabelColumnRatioEnum;
    /**
     * the background color of the input fields
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    backgroundColor?: string;
    /**
     * border style of the input fields
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    borderType?: DatabaseAppearanceFieldLayoutBorderTypeEnum;
    /**
     * the border color of the input fields
     * @type {string}
     * @memberof DatabaseAppearanceFieldLayout
     */
    borderColor?: string;
}


/**
 * @export
 */
export const DatabaseAppearanceFieldLayoutAlignmentEnum = {
    LeftRight: 'LEFT_RIGHT',
    TopBottom: 'TOP_BOTTOM'
} as const;
export type DatabaseAppearanceFieldLayoutAlignmentEnum = typeof DatabaseAppearanceFieldLayoutAlignmentEnum[keyof typeof DatabaseAppearanceFieldLayoutAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearanceFieldLayoutLabelAlignmentEnum = {
    Top: 'TOP',
    TopCentered: 'TOP_CENTERED',
    Left: 'LEFT',
    Right: 'RIGHT'
} as const;
export type DatabaseAppearanceFieldLayoutLabelAlignmentEnum = typeof DatabaseAppearanceFieldLayoutLabelAlignmentEnum[keyof typeof DatabaseAppearanceFieldLayoutLabelAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearanceFieldLayoutLabelColumnRatioEnum = {
    OneOne: 'ONE_ONE',
    ThreeTwo: 'THREE_TWO',
    TwoThree: 'TWO_THREE',
    SevenThree: 'SEVEN_THREE',
    ThreeSeven: 'THREE_SEVEN',
    OneFour: 'ONE_FOUR',
    FourOne: 'FOUR_ONE'
} as const;
export type DatabaseAppearanceFieldLayoutLabelColumnRatioEnum = typeof DatabaseAppearanceFieldLayoutLabelColumnRatioEnum[keyof typeof DatabaseAppearanceFieldLayoutLabelColumnRatioEnum];

/**
 * @export
 */
export const DatabaseAppearanceFieldLayoutBorderTypeEnum = {
    Full: 'FULL',
    Bottom: 'BOTTOM',
    None: 'NONE'
} as const;
export type DatabaseAppearanceFieldLayoutBorderTypeEnum = typeof DatabaseAppearanceFieldLayoutBorderTypeEnum[keyof typeof DatabaseAppearanceFieldLayoutBorderTypeEnum];


/**
 * Check if a given object implements the DatabaseAppearanceFieldLayout interface.
 */
export function instanceOfDatabaseAppearanceFieldLayout(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearanceFieldLayoutFromJSON(json: any): DatabaseAppearanceFieldLayout {
    return DatabaseAppearanceFieldLayoutFromJSONTyped(json, false);
}

export function DatabaseAppearanceFieldLayoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearanceFieldLayout {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alignment': !exists(json, 'alignment') ? undefined : json['alignment'],
        'labelAlignment': !exists(json, 'labelAlignment') ? undefined : json['labelAlignment'],
        'labelColumnRatio': !exists(json, 'labelColumnRatio') ? undefined : json['labelColumnRatio'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'borderType': !exists(json, 'borderType') ? undefined : json['borderType'],
        'borderColor': !exists(json, 'borderColor') ? undefined : json['borderColor'],
    };
}

export function DatabaseAppearanceFieldLayoutToJSON(value?: DatabaseAppearanceFieldLayout | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alignment': value.alignment,
        'labelAlignment': value.labelAlignment,
        'labelColumnRatio': value.labelColumnRatio,
        'backgroundColor': value.backgroundColor,
        'borderType': value.borderType,
        'borderColor': value.borderColor,
    };
}

